<!-- Секция музыкальных площадок - Organism -->
<template>
  <section class="relative bg-black py-16 lg:py-24 overflow-hidden">
    <!-- Фоновые элементы -->
    <div class="absolute inset-0">
      <div class="absolute inset-0 bg-[rgba(22,22,22,0.33)]" />
    </div>
    
    <div class="relative z-10 mx-auto max-w-7xl px-6">
      <!-- Заголовок -->
      <h2 class="platforms-title text-center mb-[20px]">
        Все площадки в одно касание
      </h2>

      <!-- Бесконечная карусель логотипов -->
      <div class="carousel-container relative py-[30px]">
        <!-- Градиентные маски по краям -->
        <div
          class="absolute left-0 top-0 bottom-0 w-16 lg:w-32 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none" />
        <div
          class="absolute right-0 top-0 bottom-0 w-16 lg:w-32 bg-gradient-to-l from-black to-transparent z-10 pointer-events-none" />

        <!-- Карусельная дорожка -->
        <div class="carousel-track">
          <!-- Первый набор логотипов -->
          <div class="carousel-slide">
            <img v-for="(platform, index) in platforms" :key="`platform-1-${index}`" :src="platform.logo"
              :alt="platform.name" class="platform-logo" loading="lazy" />
          </div>

          <!-- Дублированный набор для бесшовной анимации -->
          <div class="carousel-slide" aria-hidden="true">
            <img v-for="(platform, index) in platforms" :key="`platform-2-${index}`" :src="platform.logo"
              :alt="platform.name" class="platform-logo" loading="lazy" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'

interface Platform {
  name: string
  logo: string
}

// Все логотипы из папки venue
const platforms = ref<Platform[]>([
  { name: 'Apple Music', logo: '/images/block/venue/apple.png' },
  { name: 'Spotify', logo: '/images/block/venue/spotify.png' },
  { name: 'Amazon Music', logo: '/images/block/venue/amazon.png' },
  { name: 'Яндекс Музыка', logo: '/images/block/venue/yamusic.png' },
  { name: 'VK Музыка', logo: '/images/block/venue/vk.png' },
  { name: 'Deezer', logo: '/images/block/venue/deezer.png' },
  { name: 'TikTok', logo: '/images/block/venue/tiktok.png' },
  { name: 'iTunes', logo: '/images/block/venue/itunes.png' },
  { name: 'Google Music', logo: '/images/block/venue/gmusic.png' },
  { name: 'МТС Музыка', logo: '/images/block/venue/mtsnusic.png' },
  { name: 'Tidal', logo: '/images/block/venue/tidal.png' },
  { name: 'Звук', logo: '/images/block/venue/zvuk.png' },
  { name: 'Music', logo: '/images/block/venue/music.png' },
  { name: 'Instagram', logo: '/images/block/venue/instagram.png' }
])
</script>

<style scoped>
.platforms-title {
  font-family: 'Halvar Breitschrift', sans-serif;
  font-size: 40px;
  font-weight: 500;
  line-height: 0.93;
  background: linear-gradient(109deg, #ececec 52.01%, rgba(236, 236, 236, 0) 135.73%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.carousel-container {
  position: relative;
  overflow: hidden;
  /* Скрываем скроллбар */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.carousel-container::-webkit-scrollbar {
  display: none;
}

.carousel-track {
  display: flex;
  animation: scroll 8s linear infinite; /* Очень быстро для мобильной */
  will-change: transform;
}

.carousel-track:hover {
  animation-play-state: paused;
}

.carousel-slide {
  display: flex;
  align-items: center;
  gap: 3rem;
  flex-shrink: 0;
  padding: 0 1.5rem;
}

@media (min-width: 768px) {
  .carousel-slide {
    gap: 4rem;
    padding: 0 2rem;
  }
}

@media (min-width: 1024px) {
  .carousel-slide {
    gap: 5rem;
  }
}

.platform-logo {
  height: auto;
  max-height: 1.4375rem;
  /* 23px в rem */
  width: auto;
  object-fit: contain;
  opacity: 0.6;
  transition: opacity 0.3s ease, transform 0.3s ease;
  filter: grayscale(100%) brightness(1.2);
  flex-shrink: 0;
}

.platform-logo:hover {
  opacity: 1;
  transform: scale(1.1);
  filter: grayscale(0%) brightness(1);
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

/* Адаптивные размеры логотипов */
@media (min-width: 768px) {
  .platform-logo {
    max-height: 1.6875rem;
    /* 27px для планшетов */
  }
}

@media (min-width: 1024px) {
  .platform-logo {
    max-height: 1.875rem;
    /* 30px для десктопов */
  }
}

/* Скорость анимации для разных устройств */
@media (min-width: 768px) {
  .carousel-track {
    animation: scroll 20s linear infinite; /* Средняя скорость для планшетов */
  }
}

@media (min-width: 1024px) {
  .carousel-track {
    animation: scroll 30s linear infinite; /* Медленнее для десктопов */
  }
}
</style>
